import type * as z from 'zod/v4';

import { formatIssue, type Issue } from '../../../schema/utils/entry.js';
import { HttpStatus, type HttpStatusCode } from '../../lib/entry.js';
import { PoolbettingError } from './PoolbettingError.js';

export class ValidationError extends PoolbettingError<'VALIDATION'> {
  protected override httpStatus: HttpStatusCode = HttpStatus.InternalServerError;

  private readonly _issues: Issue[] = [];

  constructor(message = 'Validation error', options?: ErrorOptions, issues: Issue[] = []) {
    super(message, options, 'VALIDATION');
    this.name = 'ValidationError';
    this._issues = issues;
  }

  get issues(): Issue[] {
    return this._issues;
  }

  static toValidationError(zodError: z.ZodError): ValidationError {
    const issues = zodError.issues.map((issue) => formatIssue(issue));

    return new ValidationError(undefined, { cause: zodError }, issues);
  }
}
